// // import React, { useState, useEffect } from "react";
// // import "../assets/AttendanceCalculator.css";
// // import { toast, ToastContainer } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import { useDispatch, useSelector } from "react-redux";
// // import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// // import axios from "axios";

// // const SuperAdminAttendance = () => {
// //   const dispatch = useDispatch();

// //   // ✅ Redux: Get employee data
// //   const { list: employeeList, loading: empLoading } = useSelector(
// //     (state) => state.employeeReport
// //   );

// //   // ✅ Local states
// //   const [selectedUser, setSelectedUser] = useState("");
// //   const [selectedUserId, setSelectedUserId] = useState(null);
// //   const [selectedBranchId, setSelectedBranchId] = useState(null);
// //   const [superAdminId,setsuperadminid]= useState(null);

// //   const [selectedMonth, setSelectedMonth] = useState(
// //     new Date().toISOString().slice(0, 7)
// //   );
// //   const [attendanceData, setAttendanceData] = useState([]);
// //   const [loading, setLoading] = useState(false);

// //   // ✅ Fetch employees on mount
// //   useEffect(() => {
// //     dispatch(
// //       fetchEmployeeReport({
// //         page: 1,
// //         pageSize: 100,
// //         filterType: "userId",
// //         filterValue: "",
// //         branch: "",
// //         fromDate: "",
// //         toDate: "",
// //       })
// //     );
// //   }, [dispatch]);

// //   // ✅ Helper — format time
// //   const formatTime = (timeValue) => {
// //     if (!timeValue) return "--";
// //     // If already HH:mm, return as is
// //     if (/^\d{2}:\d{2}$/.test(timeValue)) return timeValue;
// //     const dateObj = new Date(timeValue);
// //     if (isNaN(dateObj)) return "--";
// //     return dateObj.toLocaleTimeString("en-IN", {
// //       hour: "2-digit",
// //       minute: "2-digit",
// //       hour12: false,
// //       timeZone: "Asia/Kolkata",
// //     });
// //   };

// //   // ✅ Fetch attendance data
// //   const fetchAttendanceData = async () => {
// //     if (!selectedUserId || !selectedMonth) {
// //       toast.info("Please select both user and month!");
// //       return;
// //     }

// //     setLoading(true);
// //     try {
// //       const res = await fetch(
// //         `https://payyug.in/api/attendance/status?employee_id=${selectedUserId}&month=${selectedMonth}`
// //       );
// //       const result = await res.json();

// //       if (result?.data?.length) {
// //         const mapped = result.data.map((r) => ({
// //           id: r.id,
// //           date: r.date,
// //           checkIn:
// //             r.check_in_time || r.checkInTime
// //               ? formatTime(r.check_in_time || r.checkInTime)
// //               : "--",
// //           checkOut:
// //             r.check_out_time || r.checkOutTime
// //               ? formatTime(r.check_out_time || r.checkOutTime)
// //               : "--",
// //           status: (r.status || "absent").trim().toLowerCase(),
// //           remarks: r.remarks || "",
// //         }));
// //         setAttendanceData(mapped);
// //       } else {
// //         toast.info("No attendance records found for this user and month.");
// //         setAttendanceData([]);
// //       }
// //     } catch (err) {
// //       console.error("🚨 Attendance Fetch Error:", err);
// //       toast.error("❌ Failed to fetch attendance data!");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };
// //   // console.log(selectedBranchId);
// //   // console.log(selectedUserId);
// //      console.log("selected month",selectedMonth);
// //   // ✅ Handle field edit
// //   const handleAttendanceChange = (index, field, value) => {
// //     const updated = [...attendanceData];
// //     updated[index][field] = value;
// //     setAttendanceData(updated);
// //   };

// //   // ✅ Save record changes
// //   const handleSave = async (row) => {

// //           console.error("Attendance Save:", row);
// //           console.error("Attendance Save :", row.id);
// //           console.error("Attendance Save :", row);

// //     try {
// //       const payload = {
// //         attendance_id: row.id,
// //         check_in_time:
// //           row.checkIn !== "--" ? `${row.date} ${row.checkIn}:00` : null,
// //         check_out_time:
// //           row.checkOut !== "--" ? `${row.date} ${row.checkOut}:00` : null,
// //         status: row.status,
// //         // remarks: row.remarks,
// //       };

// //       const res = await fetch("https://payyug.in/api/attendance/correct", {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify(payload),
// //       });

// //       const result = await res.json();
// //       if (res.ok) {
// //         toast.success("✅ Attendance updated successfully!");
// //         fetchAttendanceData();
// //       } else {
// //         toast.error(`❌ ${result.error || "Failed to update attendance"}`);
// //       }
// //     } catch (error) {
// //       console.error("Attendance Save Error:", error);
// //       toast.error("🚨 Error saving attendance data!");
// //     }
// //   };

// //   const handlecalcclick = async () => {
// //      const [year, month] = selectedMonth.split("-");
// //     try {
// //       const payload = {
// //         employeeId: selectedUserId,
// //         month: month,
// //         year: year,
// //         superAdminId: superAdminId,
// //         branchId: selectedBranchId,
// //       };

// //       const response = await axios.post(
// //         "https://payyug.in/api/create/finalize",
// //         payload
// //       );

// //       console.log("Finalize salary success:", response.data);
// //       // alert("Salary finalized successfully!");
// //       toast.success("Salary finalized successfully!");
// //     } catch (error) {
// //       console.error("Error finalizing salary:", error);
// //      toast.error(
// //         error.response?.data?.message || "Something went wrong while finalizing."
// //       );
// //     }
// //   };

// //   return (
// //     <div className="SuperAdminAttendance-container">
// //       <h1 className="SuperAdminAttendance-title">Super Admin Attendance Panel</h1>

// //       {/* Filters */}
// //       <div className="SuperAdminAttendance-filters">
// //         <div className="SuperAdminAttendance-filters-input-fields">
// //         {/* User Dropdown */}
// //         <div className="SuperAdminAttendance-filterGroup">
// //         <label className="SuperAdminAttendance-label">Select User</label>
// //         <select
// //           className="SuperAdminAttendance-input"
// //           value={selectedUser?.id || ""}
// //           onChange={(e) => {
// //             const userId = Number(e.target.value);
// //             const userObj = employeeList?.find((u) => u.id === userId);
// //             setSelectedUser(userObj?.fullName);
// //             setSelectedUserId(userObj?.id || null);
// //             setSelectedBranchId(userObj?.branchId || null);
// //             setsuperadminid(userObj?.superAdminId || null);
// //           }}
// //         >
// //           <option value="">Select User</option>
// //           {empLoading ? (
// //             <option>Loading...</option>
// //           ) : employeeList && employeeList.length > 0 ? (
// //             employeeList.map((u) => (
// //               <option key={u.id} value={u.id}>
// //                 {u.fullName} ({u.branchName})
// //               </option>
// //             ))
// //           ) : (
// //             <option>No employees found</option>
// //           )}
// //         </select>
// //       </div>

// //         {/* Month */}
// //         <div className="SuperAdminAttendance-filterGroup">
// //           <label className="SuperAdminAttendance-label">Select Month</label>
// //           <input
// //             type="month"
// //             className="SuperAdminAttendance-input"
// //             value={selectedMonth}
// //             onChange={(e) => setSelectedMonth(e.target.value)}
// //           />
// //         </div>
// //          </div>

// //         {/* Filter Button */}
// //         <div className="SuperAdminAttendance-filterGroup">
// //           <label className="SuperAdminAttendance-label">&nbsp;</label>
// //           <button
// //             className="SuperAdminAttendance-btn"
// //             onClick={fetchAttendanceData}
// //             disabled={loading || empLoading}
// //           >
// //             {loading ? "Loading..." : "Filter"}
// //           </button>
// //         </div>
// //       </div>

// //       {/* Summary */}
// //       {selectedUser && attendanceData.length > 0 && (
// //         <div className="SuperAdminAttendance-userMonthly">
// //           <h2 className="SuperAdminAttendance-subtitle">
// //             Monthly Summary - {selectedUser}
// //           </h2>
// //           <div className="SuperAdminAttendance-summary">
// //             <div className="SuperAdminAttendance-card green">
// //               <h2>Days Present</h2>
// //               <p>
// //                 {
// //                   attendanceData.filter(
// //                     (a) =>
// //                       a.status === "present" || a.status === "late present"
// //                   ).length
// //                 }
// //               </p>
// //             </div>
// //             <div className="SuperAdminAttendance-card purple">
// //               <h2>Half Days</h2>
// //               <p>{attendanceData.filter((a) => a.status === "half day").length}</p>
// //             </div>
// //             <div className="SuperAdminAttendance-card red">
// //               <h2>Leaves</h2>
// //               <p>
// //                 {
// //                   attendanceData.filter(
// //                     (a) => a.status === "leave" || a.status === "absent"
// //                   ).length
// //                 }
// //               </p>
// //             </div>
// //             <div className="SuperAdminAttendance-card blue">
// //               <h2>Total Days</h2>
// //               <p>{attendanceData.length}</p>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* Table */}
// //       {selectedUser && (
// //         <div className="SuperAdminAttendance-tableWrapper">
// //           <h2 className="SuperAdminAttendance-subtitle">
// //             Manage Daily Attendance - {selectedMonth}
// //           </h2>
// //           <table className="SuperAdminAttendance-table">
// //             <thead>
// //               <tr>
// //                 <th>Date</th>
// //                 <th>Status</th>
// //                 <th>Check-In</th>
// //                 <th>Check-Out</th>

// //                 <th>Action</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {attendanceData.length > 0 ? (
// //                 attendanceData.map((row, index) => (
// //                   <tr key={index}>
// //                     <td>{row.date}</td>
// //                     <td>
// //                       <select
// //                         value={row.status}
// //                         onChange={(e) =>
// //                           handleAttendanceChange(index, "status", e.target.value)
// //                         }
// //                       >
// //                         <option value="present">Present</option>
// //                         <option value="late">Late</option>
// //                         <option value="half day">Half Day</option>
// //                         <option value="leave">Leave</option>
// //                         <option value="absent">Absent</option>
// //                       </select>
// //                     </td>
// //                     <td>
// //                       <input
// //                         type="time"
// //                         value={row.checkIn !== "--" ? row.checkIn : ""}
// //                         onChange={(e) =>
// //                           handleAttendanceChange(index, "checkIn", e.target.value)
// //                         }
// //                       />
// //                     </td>
// //                     <td>
// //                       <input
// //                         type="time"
// //                         value={row.checkOut !== "--" ? row.checkOut : ""}
// //                         onChange={(e) =>
// //                           handleAttendanceChange(index, "checkOut", e.target.value)
// //                         }
// //                       />
// //                     </td>

// //                     <td>
// //                       <button
// //                         className="SuperAdminAttendance-btn"
// //                         onClick={() => handleSave(row)}
// //                       >
// //                       Update
// //                       </button>
// //                     </td>
// //                   </tr>
// //                 ))
// //               ) : (
// //                 <tr>
// //                   <td colSpan="6" style={{ textAlign: "center", color: "#999" }}>
// //                     No attendance data available.
// //                   </td>
// //                 </tr>
// //               )}
// //             </tbody>
// //           </table>
// //           <button className="calc-att-btn" onClick={handlecalcclick}>Calculate</button>
// //         </div>
// //       )}

// //       <ToastContainer position="top-right" autoClose={3000} theme="colored" />
// //     </div>
// //   );
// // };

// // export default SuperAdminAttendance;

// import React, { useState, useEffect } from "react";
// import "../assets/AttendanceCalculator.css";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// import axios from "axios";

// const SuperAdminAttendance = () => {
//   const dispatch = useDispatch();

//   const { list: employeeList, loading: empLoading } = useSelector(
//     (state) => state.employeeReport
//   );

//   // ✅ Store full user object
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [selectedBranchId, setSelectedBranchId] = useState(null);
//   const [superAdminId, setsuperadminid] = useState(null);

//   const [selectedMonth, setSelectedMonth] = useState(
//     new Date().toISOString().slice(0, 7)
//   );
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // ✅ Fetch employees
//   useEffect(() => {
//     dispatch(
//       fetchEmployeeReport({
//         page: 1,
//         pageSize: 100,
//         filterType: "userId",
//         filterValue: "",
//         branch: "",
//         fromDate: "",
//         toDate: "",
//       })
//     );
//   }, [dispatch]);

//   // ✅ Format time helper
//   const formatTime = (timeValue) => {
//     if (!timeValue) return "--";
//     if (/^\d{2}:\d{2}$/.test(timeValue)) return timeValue;

//     const dateObj = new Date(timeValue);
//     if (isNaN(dateObj)) return "--";

//     return dateObj.toLocaleTimeString("en-IN", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false,
//       timeZone: "Asia/Kolkata",
//     });
//   };

//   // ✅ Fetch attendance
//   const fetchAttendanceData = async () => {
//     if (!selectedUserId || !selectedMonth) {
//       toast.info("Please select both user and month!");
//       return;
//     }

//     setLoading(true);
//     try {
//       const res = await fetch(
//         `https://payyug.in/api/attendance/status?employee_id=${selectedUserId}&month=${selectedMonth}`
//       );

//       const result = await res.json();

//       if (result?.data?.length) {
//         const mapped = result.data.map((r) => ({
//           id: r.id,
//           date: r.date,
//           checkIn:
//             r.check_in_time || r.checkInTime
//               ? formatTime(r.check_in_time ?? r.checkInTime)
//               : "--",
//           checkOut:
//             r.check_out_time || r.checkOutTime
//               ? formatTime(r.check_out_time ?? r.checkOutTime)
//               : "--",
//           status: (r.status || "absent").trim().toLowerCase(),
//           remarks: r.remarks || "",
//         }));

//         setAttendanceData(mapped);
//       } else {
//         toast.info("No attendance records found for this user and month.");
//         setAttendanceData([]);
//       }
//     } catch (err) {
//       console.error("Attendance Fetch Error:", err);
//       toast.error("❌ Failed to fetch attendance data!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Edit handler
//   const handleAttendanceChange = (index, field, value) => {
//     const updated = [...attendanceData];
//     updated[index][field] = value;
//     setAttendanceData(updated);
//   };

//   // ✅ Save update
//   const handleSave = async (row) => {
//     try {
//       const payload = {
//         attendance_id: row.id,
//         check_in_time:
//           row.checkIn !== "--" && row.checkIn
//             ? `${row.date} ${row.checkIn}:00`
//             : null,
//         check_out_time:
//           row.checkOut !== "--" && row.checkOut
//             ? `${row.date} ${row.checkOut}:00`
//             : null,
//         status: row.status,
//       };

//       const res = await fetch("https://payyug.in/api/attendance/correct", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const result = await res.json();

//       if (res.ok) {
//         toast.success("✅ Attendance updated successfully!");
//         fetchAttendanceData();
//       } else {
//         toast.error(`❌ ${result.error || "Failed to update attendance"}`);
//       }
//     } catch (error) {
//       console.error("Attendance Save Error:", error);
//       toast.error("🚨 Error saving attendance data!");
//     }
//   };

//   // ✅ Calculate Salary
//   const handlecalcclick = async () => {
//     if (!selectedUserId || !selectedBranchId || !superAdminId) {
//       toast.warning("Please select a valid employee first");
//       return;
//     }

//     const [year, month] = selectedMonth.split("-");

//     try {
//       const payload = {
//         employeeId: selectedUserId,
//         month: month,
//         year: year,
//         superAdminId: superAdminId,
//         branchId: selectedBranchId,
//       };

//       const response = await axios.post(
//         "https://payyug.in/api/create/finalize",
//         payload
//       );

//       if (!response.data || response.data.length === 0) {
//         toast.warning("No Attendance Available");
//         return;
//       }

//       toast.success("Salary finalized successfully!");
//     } catch (error) {
//       console.error("Error finalizing salary:", error);
//       toast.error(
//         error.response?.data?.message ||
//           "Something went wrong while finalizing."
//       );
//     }
//   };

//   return (
//     <div className="SuperAdminAttendance-container">
//       <h1 className="SuperAdminAttendance-title">
//         Super Admin Attendance Panel
//       </h1>

//       <div className="SuperAdminAttendance-filters">
//         <div className="SuperAdminAttendance-filters-input-fields">
//           <div className="SuperAdminAttendance-filterGroup">
//             <label className="SuperAdminAttendance-label">
//               Select User
//             </label>
//             <select
//               className="SuperAdminAttendance-input"
//               value={selectedUser?.id || ""}
//               onChange={(e) => {
//                 const userId = Number(e.target.value);
//                 const userObj = employeeList?.find(
//                   (u) => u.id === userId
//                 );

//                 setSelectedUser(userObj || null);
//                 setSelectedUserId(userObj?.id || null);
//                 setSelectedBranchId(userObj?.branchId || null);
//                 setsuperadminid(userObj?.superAdminId || null);
//               }}
//             >
//               <option value="">Select User</option>
//               {empLoading ? (
//                 <option>Loading...</option>
//               ) : employeeList && employeeList.length > 0 ? (
//                 employeeList.map((u) => (
//                   <option key={u.id} value={u.id}>
//                     {u.fullName} ({u.branchName})
//                   </option>
//                 ))
//               ) : (
//                 <option>No employees found</option>
//               )}
//             </select>
//           </div>

//           <div className="SuperAdminAttendance-filterGroup">
//             <label className="SuperAdminAttendance-label">
//               Select Month
//             </label>
//             <input
//               type="month"
//               className="SuperAdminAttendance-input"
//               value={selectedMonth}
//               onChange={(e) => setSelectedMonth(e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="SuperAdminAttendance-filterGroup">
//           <label className="SuperAdminAttendance-label">&nbsp;</label>
//           <button
//             className="SuperAdminAttendance-btn"
//             onClick={fetchAttendanceData}
//             disabled={loading || empLoading}
//           >
//             {loading ? "Loading..." : "Filter"}
//           </button>
//         </div>
//       </div>

//       {selectedUser && attendanceData.length > 0 && (
//         <div className="SuperAdminAttendance-userMonthly">
//           <h2 className="SuperAdminAttendance-subtitle">
//             Monthly Summary - {selectedUser.fullName}
//           </h2>
//           <div className="SuperAdminAttendance-summary">
//             <div className="SuperAdminAttendance-card green">
//               <h2>Days Present</h2>
//               <p>
//                 {
//                   attendanceData.filter(
//                     (a) =>
//                       a.status === "present" || a.status === "late"
//                   ).length
//                 }
//               </p>
//             </div>

//             <div className="SuperAdminAttendance-card purple">
//               <h2>Half Days</h2>
//               <p>
//                 {
//                   attendanceData.filter(
//                     (a) => a.status === "half day"
//                   ).length
//                 }
//               </p>
//             </div>

//             <div className="SuperAdminAttendance-card red">
//               <h2>Leaves</h2>
//               <p>
//                 {
//                   attendanceData.filter(
//                     (a) =>
//                       a.status === "leave" ||
//                       a.status === "absent"
//                   ).length
//                 }
//               </p>
//             </div>

//             <div className="SuperAdminAttendance-card blue">
//               <h2>Total Days</h2>
//               <p>{attendanceData.length}</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {selectedUser && (
//         <div className="SuperAdminAttendance-tableWrapper">
//           <h2 className="SuperAdminAttendance-subtitle">
//             Manage Daily Attendance - {selectedMonth}
//           </h2>
//           <table className="SuperAdminAttendance-table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Status</th>
//                 <th>Check-In</th>
//                 <th>Check-Out</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {attendanceData.length > 0 ? (
//                 attendanceData.map((row, index) => (
//                   <tr key={row.id}>
//                     <td>
//                       {new Date(row.date).toLocaleDateString(
//                         "en-IN"
//                       )}
//                     </td>

//                     <td>
//                       <select
//                         value={row.status}
//                         onChange={(e) =>
//                           handleAttendanceChange(
//                             index,
//                             "status",
//                             e.target.value
//                           )
//                         }
//                       >
//                         <option value="present">Present</option>
//                         <option value="late">Late</option>
//                         <option value="half day">Half Day</option>
//                         <option value="leave">Leave</option>
//                         <option value="absent">Absent</option>
//                       </select>
//                     </td>

//                     <td>
//                       <input
//                         type="time"
//                         value={
//                           row.checkIn !== "--"
//                             ? row.checkIn
//                             : ""
//                         }
//                         onChange={(e) =>
//                           handleAttendanceChange(
//                             index,
//                             "checkIn",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="time"
//                         value={
//                           row.checkOut !== "--"
//                             ? row.checkOut
//                             : ""
//                         }
//                         onChange={(e) =>
//                           handleAttendanceChange(
//                             index,
//                             "checkOut",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="SuperAdminAttendance-btn"
//                         onClick={() => handleSave(row)}
//                       >
//                         Update
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td
//                     colSpan="6"
//                     style={{
//                       textAlign: "center",
//                       color: "#999",
//                     }}
//                   >
//                     No attendance data available.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>

//           <button
//             className="calc-att-btn"
//             onClick={handlecalcclick}
//           >
//             Calculate
//           </button>
//         </div>
//       )}

//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         theme="colored"
//       />
//     </div>
//   );
// };

// export default SuperAdminAttendance;

import React, { useState, useEffect } from "react";
import "../assets/AttendanceCalculator.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import axios from "axios";

const SuperAdminAttendance = () => {
  const dispatch = useDispatch();

  const { list: employeeList, loading: empLoading } = useSelector(
    (state) => state.employeeReport,
  );

  const [selectedUser, setSelectedUser] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [superAdminId, setsuperadminid] = useState(null);

  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toISOString().slice(0, 7),
  );
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    employee_id: "",
    attendance_date: "",
    attendance_time: "09:30",
    checkout_time: "18:30",
  });

  useEffect(() => {
    dispatch(
      fetchEmployeeReport({ page: 1, pageSize: 100, filterType: "userId" }),
    );
  }, [dispatch]);

  const getImageUrl = (img) => {
    if (!img || img === "N/A" || img === "null") return null;
    if (img.startsWith("http")) return img;
    const cleanPath = img.startsWith("/") ? img.substring(1) : img;
    return `https://payyug.in/${encodeURI(cleanPath)}`;
  };

  useEffect(() => {
    if (selectedUserId)
      setFormData((prev) => ({ ...prev, employee_id: selectedUserId }));
  }, [selectedUserId]);

  const formatTime = (timeValue) => {
    if (!timeValue) return "--";
    if (/^\d{2}:\d{2}$/.test(timeValue)) return timeValue;
    const dateObj = new Date(timeValue);
    if (isNaN(dateObj)) return "--";
    return dateObj.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "Asia/Kolkata",
    });
  };

  const fetchAttendanceData = async () => {
    if (!selectedUserId || !selectedMonth) {
      toast.info("Please select both user and month!");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(
        `https://payyug.in/api/attendance/status?employee_id=${selectedUserId}&month=${selectedMonth}`,
      );

      // const res = await fetch(`https://payyug.in/api/attendance/status?admin_id=52&month=${selectedMonth}`);

      const result = await res.json();

      if (result?.data?.length) {
        const mapped = result.data.map((r) => ({
          id: r.id,
          date: r.date,
          checkIn:
            r.check_in_time || r.checkInTime
              ? formatTime(r.check_in_time || r.checkInTime)
              : "--",
          checkOut:
            r.check_out_time || r.checkOutTime
              ? formatTime(r.check_out_time || r.checkOutTime)
              : "--",
          status: (r.status || "absent").trim().toLowerCase(),
          agent_lat: r.agent_lat || "N/A",
          agent_lng: r.agent_lng || "N/A",
          location: r.location || "N/A",
          photo_url: getImageUrl(r.photo_url) || "N/A",
        }));
        setAttendanceData(mapped);
      } else {
        toast.info("No records found.");
        setAttendanceData([]);
      }
    } catch (err) {
      toast.error("❌ Failed to fetch data!");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (row) => {
    try {
      const payload = {
        employee_id: Number(selectedUserId),
        attendance_date: row.date, // YYYY-MM-DD

        // Convert HH:mm → HH:mm:ss
        attendance_time:
          row.checkIn && row.checkIn !== "--"
            ? `${row.checkIn}:00`
            : "09:30:00",

        // Convert to full DATETIME or null
        checkout_time:
          row.checkOut && row.checkOut !== "--"
            ? `${row.date} ${row.checkOut}:00`
            : null,

        // 🔥 THIS IS IMPORTANT
        manual_status: row.status,
      };

      console.log("UPDATE PAYLOAD:", payload);

      const res = await axios.put(
        "https://payyug.in/api/attendance/update",
        payload,
      );

      if (res.status === 200 || res.status === 201) {
        toast.success(`✅ Attendance for ${row.date} updated`);
        fetchAttendanceData();
      }
    } catch (error) {
      console.error("Update Error:", error);
      toast.error(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "❌ Attendance update failed",
      );
    }
  };

  const handleAttendanceChange = (index, field, value) => {
    const updated = [...attendanceData];
    updated[index][field] = value;
    setAttendanceData(updated);
  };

  // Rest of handleCreateSubmit and handlecalcclick remains the same...
  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        employee_id: Number(formData.employee_id),
        attendance_date: formData.attendance_date,
        attendance_time: `${formData.attendance_time}:00`,
        checkout_time: `${formData.attendance_date} ${formData.checkout_time}:00`,
      };
      const res = await axios.post(
        "https://payyug.in/api/create-attendence/custom",
        payload,
      );
      if (res.status === 200 || res.status === 201) {
        toast.success("✅ Attendance Created!");
        setIsModalOpen(false);
        fetchAttendanceData();
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "Creation failed",
      );
    }
  };

  const handlecalcclick = async () => {
    const [year, month] = selectedMonth.split("-");
    try {
      const payload = {
        employeeId: selectedUserId,
        month,
        year,
        superAdminId,
        branchId: selectedBranchId,
      };
      const response = await axios.post(
        "https://payyug.in/api/attendence/finalize-new",
        payload,
      );

      console.log("SERVER RESPONSE:", response.data); // <--- ADD THIS LOG

      if (response.data.success === true || response.data.success === "true") {
        toast.success("Salary finalized successfully!");
      } else {
        toast.error(response.data.message || "Finalization failed.");
      }
    } catch (error) {
      console.error("CATCH ERROR:", error); // <--- ADD THIS LOG
      toast.error(
        error.response?.data?.message || "An unexpected error occurred.",
      );
    }
  };

  return (
    <div className="SuperAdminAttendance-container">
      <div className="SuperAdminAttendance-header">
        <h1 className="SuperAdminAttendance-title"> Attendance Panel</h1>
        <button className="create-att-btn" onClick={() => setIsModalOpen(true)}>
          + Create Attendance
        </button>
      </div>

      <div className="SuperAdminAttendance-filters">
        <div className="SuperAdminAttendance-filterGroup">
          <label className="SuperAdminAttendance-label">Select User</label>
          <select
            className="SuperAdminAttendance-input"
            value={selectedUserId || ""}
            onChange={(e) => {
              const userId = Number(e.target.value);
              const userObj = employeeList?.find((u) => u.id === userId);
              setSelectedUser(userObj?.fullName);
              setSelectedUserId(userObj?.id || null);
              setSelectedBranchId(userObj?.branchId || null);
              setsuperadminid(userObj?.superAdminId || null);
            }}
          >
            <option value="">Select User</option>
            {employeeList?.map((u) => (
              <option key={u.id} value={u.id}>
                {u.fullName} ({u.branchName})
              </option>
            ))}
          </select>
        </div>
        <div className="SuperAdminAttendance-filterGroup">
          <label className="SuperAdminAttendance-label">Select Month</label>
          <input
            type="month"
            className="SuperAdminAttendance-input"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          />
        </div>
        <div className="SuperAdminAttendance-filterGroup">
          <label className="SuperAdminAttendance-label">&nbsp;</label>
          <button
            className="SuperAdminAttendance-btn"
            onClick={fetchAttendanceData}
            disabled={loading}
          >
            Filter
          </button>
        </div>
      </div>

      {selectedUser && attendanceData.length > 0 && (
        <div className="SuperAdminAttendance-userMonthly">
          <h2 className="SuperAdminAttendance-subtitle">
            Monthly Summary - {selectedUser}
          </h2>
          <div className="SuperAdminAttendance-summary">
            <div className="SuperAdminAttendance-card green">
              <h2>Days Present</h2>
              <p>
                {
                  attendanceData.filter((a) =>
                    ["present", "late", "late present"].includes(a.status),
                  ).length
                }
              </p>
            </div>
            <div className="SuperAdminAttendance-card purple">
              <h2>Half Days</h2>
              <p>
                {attendanceData.filter((a) => a.status === "half day").length}
              </p>
            </div>
            <div className="SuperAdminAttendance-card red">
              <h2>Leaves / Absent</h2>
              <p>
                {
                  attendanceData.filter((a) =>
                    ["leave", "absent"].includes(a.status),
                  ).length
                }
              </p>
            </div>
            <div className="SuperAdminAttendance-card blue">
              <h2>Total Days</h2>
              <p>{attendanceData.length}</p>
            </div>
          </div>
        </div>
      )}

      {selectedUser && (
        <div className="SuperAdminAttendance-tableWrapper">
          <h2 className="SuperAdminAttendance-subtitle">
            Manage Daily Attendance
          </h2>
          <table className="SuperAdminAttendance-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>Check-In</th>
                <th>Check-Out</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Location</th>
                <th>Photo</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {attendanceData.map((row, index) => (
                <tr key={index}>
                  <td>{row.date}</td>
                  <td>
                    <select
                      value={row.status}
                      onChange={(e) =>
                        handleAttendanceChange(index, "status", e.target.value)
                      }
                    >
                      <option value="present">Present</option>
                      <option value="late">Late</option>
                      <option value="half day">Half Day</option>
                      <option value="leave">Leave</option>
                      <option value="absent">Absent</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="time"
                      value={row.checkIn !== "--" ? row.checkIn : ""}
                      onChange={(e) =>
                        handleAttendanceChange(index, "checkIn", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="time"
                      value={row.checkOut !== "--" ? row.checkOut : ""}
                      onChange={(e) =>
                        handleAttendanceChange(
                          index,
                          "checkOut",
                          e.target.value,
                        )
                      }
                    />
                  </td>
                  <td>{row.agent_lat}</td>
                  <td>{row.agent_lng}</td>
                  <td>{row.location}</td>
                  <td>
                    {row.photo_url && row.photo_url !== "N/A" ? (
                      <a
                        href={row.photo_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={row.photo_url}
                          alt="Attendance"
                          style={{
                            width: "45px",
                            height: "45px",
                            borderRadius: "6px",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                            cursor: "zoom-in",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://via.placeholder.com/45?text=Error";
                          }}
                        />
                      </a>
                    ) : (
                      <span style={{ color: "#888", fontSize: "12px" }}>
                        No Photo
                      </span>
                    )}
                  </td>
                  <td>
                    <button
                      className="update-btn"
                      onClick={() => handleSave(row)}
                    >
                      Update
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="calc-att-btn" onClick={handlecalcclick}>
            Finalize & Calculate Salary
          </button>
        </div>
      )}

      {/* Modal remains the same... */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Create Custom Attendance</h3>
            <form onSubmit={handleCreateSubmit}>
              <div className="form-group">
                <label>Date</label>
                <input
                  type="date"
                  required
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      attendance_date: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Check-in Time</label>
                <input
                  type="time"
                  defaultValue="09:30"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      attendance_time: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Check-out Time</label>
                <input
                  type="time"
                  defaultValue="18:30"
                  onChange={(e) =>
                    setFormData({ ...formData, checkout_time: e.target.value })
                  }
                />
              </div>
              <div className="modal-btns">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="save-btn">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default SuperAdminAttendance;
